import api from '../../plugins/api';

// POST /api/crm/vin-blacklist/import â ÑÐ°Ð¹Ð» .xlsx/.xls/.csv: ÐºÐ¾Ð»Ð¾Ð½ÐºÐ° Â«VINÂ» Ð¸, Ð¿Ð¾ Ð¶ÐµÐ»Ð°Ð½Ð¸Ñ, Â«ÐÑÐ¸ÑÐ¸Ð½Ð°Â».
const importVinBlacklist = (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));

  return api.post('/api/crm/vin-blacklist/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export default importVinBlacklist;
